import AdminLayout from "../../layout/AdminLayout";

export default function DefaultCampaignDetails() {

  return (
    <AdminLayout title={"Puzzle Kampanyası Ekle"}>
      <h1>Default Campaign</h1>
    </AdminLayout>
  );
}